export default __webpack_public_path__ + "static/media/placeholder.13b59797.jpg";